var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Breadcrumb',{attrs:{"breadcrumbs":_vm.breadcrumbs,"max":3,"data-identifier":_vm.dataIdentifier}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }